import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "invoice-cost-title"
}
const _hoisted_2 = { class: "invoice-cost-table" }
const _hoisted_3 = {
  key: 0,
  class: "borderless-table"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "invoice-cost-tr" }, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Cost per unit"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Quantity"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-right",
      scope: "col"
    }, "Total cost")
  ])
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "align-right" }
const _hoisted_8 = {
  key: 1,
  class: "invoice-cost-title"
}
const _hoisted_9 = {
  key: 2,
  class: "borderless-table"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "invoice-bold" }, "Name"),
  /*#__PURE__*/_createElementVNode("td", { class: "invoice-bold" }, "Cost per hour"),
  /*#__PURE__*/_createElementVNode("td", { class: "invoice-bold" }, "Quantity"),
  /*#__PURE__*/_createElementVNode("td", { class: "align-right invoice-bold" }, "Total cost")
], -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "align-right" }
const _hoisted_18 = { class: "borderless-table" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { class: "invoice-bold" }, "Subtotal", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_23 = { class: "align-right invoice-bold" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_26 = { class: "align-right" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_30 = { class: "align-right invoice-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrTooltip = _resolveComponent("NrTooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($props.lineItems.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Line item"))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      ($props.lineItems.length > 0)
        ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.lineItems, (lineItem, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: `line-item-${lineItem.id}-${index}`
                }, [
                  (lineItem.name?.length > 15)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_5, [
                        _createVNode(_component_NrTooltip, {
                          label: lineItem.name
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($options.truncate(lineItem.name, { length: 40 })), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"])
                      ]))
                    : (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(lineItem.name), 1)),
                  _createElementVNode("td", null, _toDisplayString($options.formatCost(lineItem.cost, 3) || '$0.00'), 1),
                  _createElementVNode("td", null, _toDisplayString(lineItem.quantity), 1),
                  _createElementVNode("td", _hoisted_7, _toDisplayString($options.formatCost(lineItem.cost * lineItem.quantity)), 1)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      ($props.staffHours.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Staff hours "))
        : _createCommentVNode("", true),
      ($props.staffHours.length > 0)
        ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
            _createElementVNode("tbody", null, [
              _hoisted_10,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.staffHours, (hour, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: `hour-${index}`
                }, [
                  _createElementVNode("td", null, [
                    ($options.showInvoiceStaffName)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                          (hour.user.name)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(hour.user.name), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_13, "(Staff)"))
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_14, [
                          (hour.user.title)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(hour.user.title), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_16, "(Staff)"))
                        ]))
                  ]),
                  _createElementVNode("td", null, _toDisplayString($options.formatCost(hour.hourly_rate)), 1),
                  _createElementVNode("td", null, _toDisplayString(hour.staff_hours), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString($options.formatCost(hour.staff_cost)), 1)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("table", _hoisted_18, [
        _createElementVNode("tbody", null, [
          ($props.lineItems.length > 0 || $props.staffHours.length > 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                _hoisted_20,
                _hoisted_21,
                _hoisted_22,
                _createElementVNode("td", _hoisted_23, _toDisplayString($options.formatCost($data.subtotalInvoiceAmount)), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.surcharges, (surcharge, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: `surcharge-${index}`
            }, [
              _hoisted_24,
              _hoisted_25,
              _createElementVNode("td", null, _toDisplayString($options.setSurchargeName(surcharge)), 1),
              _createElementVNode("td", _hoisted_26, _toDisplayString($options.formatSurcharge(surcharge)), 1)
            ]))
          }), 128)),
          _createElementVNode("tr", null, [
            _hoisted_27,
            _hoisted_28,
            _hoisted_29,
            _createElementVNode("td", _hoisted_30, " Total: " + _toDisplayString($options.formatCost($props.totalAmount / 100)), 1)
          ])
        ])
      ])
    ])
  ], 64))
}